// Others
import axiosClient from './axiosClient';
import { IBodyUpdate, IQueryParamBase } from '~/utils/interface/common';
import { urlApiCoupon } from '~/utils/constants/apis';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import { ICoupon, IFormCoupon, ICouponDetail, IFormUpdateCoupon } from '~/utils/interface/coupon';

const couponApi = {
  getListCoupon: (params: IQueryParamBase) => {
    const url = urlApiCoupon.getListCoupon;
    return axiosClient.get<IBaseResponse<IListDataResponse<ICoupon[]>>>(url, { params });
  },

  getDetailCoupon: (id: string) => {
    const url = urlApiCoupon.getDetailCoupon(id);
    return axiosClient.get<IBaseResponse<ICouponDetail>>(url);
  },

  createCoupon: (body: IFormCoupon) => {
    const url = urlApiCoupon.createCoupon;
    return axiosClient.post<IBaseResponse>(url, body);
  },

  updateCoupon: (params: IBodyUpdate<IFormUpdateCoupon>) => {
    const { id, body } = params;
    const url = urlApiCoupon.updateCoupon(id);
    return axiosClient.put<IBaseResponse>(url, body);
  },

  deleteCoupon: (id: string) => {
    const url = urlApiCoupon.deleteCoupon(id);
    return axiosClient.delete<IBaseResponse>(url);
  },
};

export default couponApi;
